// src/components/SessionTimeout.js
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { clearToken } from '../Redux/Auth/TokenSlice';
import { useNavigate } from 'react-router-dom';
import { clearUser } from '../Redux/User/UserSlice';

const SessionTimeout = ({ timeoutDuration = 1800000 }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const timerRef = useRef(null);

    const logoutAction = async () => {
        const token = sessionStorage.getItem("jwt_token");

        sessionStorage.removeItem("jwt_token");
        sessionStorage.removeItem("email");
        // sessionStorage.removeItem("username");
        sessionStorage.removeItem("user");
        dispatch(clearUser());
        dispatch(clearToken());
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/logout`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.ok) {

            } else {
                console.error("Failed to log out user");
            }
        } catch (error) {
            console.error("Failed to fetch template menu items", error);
        }
        alert('Session expired due to inactivity.');
        navigate("/auth/login");
    };

    const clearSession = () => {
        logoutAction();
    };

    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(clearSession, timeoutDuration);
    };

    useEffect(() => {
        const events = ['mousemove', 'keypress'];

        const resetTimerOnEvent = () => resetTimer();

        events.forEach(event => {
            window.addEventListener(event, resetTimerOnEvent);
        });

        resetTimer();

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            events.forEach(event => {
                window.removeEventListener(event, resetTimerOnEvent);
            });
        };
    }, [timeoutDuration]);

    return null;
};

export default SessionTimeout;
